import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import { useStoreon } from 'storeon/react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import cnBind from 'classnames/bind';
import {
  GxButton,
  GxForm,
  GxIcon,
  GxSpinner,
} from '@garpix/garpix-web-components-react';
import { TCertificatePayment } from '@/types';
import { Events, State } from '@/interfaces';
import Input from '../../../../../../components/Input';
import styles from './styles/index.module.scss';
import {
  ITEMS_BLOCK_PAY_HERE,
  PAYMENT_DEPOSITS_ITEMS,
  PAYMENT_TYPE,
} from '../../../../consts';
import InputNumbers from '../../../../../../components/InputNumbers';
import Radio from '../../../../../../components/Radio';
import ModalLayout from '../../../../../../components/ModalLayout';
import { DeleteIcon, PlusIcon } from '../../../../../../assets';
import { TYPE_USER, TYPES_DEPOSITS } from '../../../../../../const';
import { checkFlagBtnPay } from '../../helpers';
import {
  createPaymentCertificate,
  createPaymentDeposit,
  createPaymentServices,
  handleOnPressKey
} from '../../../../helpers';
import { ContextDeposit, SIDEBAR_TYPES, TYPES } from '../../const';
import ToastPrintCertificate from '../../../../../../components/ToastPrintCertificate';
import useModalFlag from '../../../../../../hooks/useModalFlag';
import ModalTransferCertificate from '../../../ModalTransferCertificate';
import { IFormikProps, IModalPayHereProps, IPaymentMethod, IPrintFlags } from '../../interfaces';
import { headerTypeTitle } from './const';

const validateCertificateNumber = (value: string): boolean => {
    if (!value || value === '') return true; // Пустое значение допустимо
    // Регулярное выражение позволяет: кириллица, латиница, цифры, слеш (/), тире (-), нижнее подчеркивание (_)
    const regex = /^[a-zA-Zа-яА-ЯёЁ0-9\-_/]+$/;
    return regex.test(value);
};

const ModalPayHere: FC<IModalPayHereProps> = ({
  count,
  data,
  headerType,
  onRequestClose,
  flag,
  userInfo,
  deposit_type,
  priceInfo,
}) => {
  const [activeItem, setActiveItem] = useState<PAYMENT_TYPE | null>(PAYMENT_TYPE.IN_CASH);
  const [arrItem, setArrItem] = useState<IPaymentMethod[]>([]);
  const { currentUser, dispatch, depositListUser } = useStoreon<State, Events>('currentUser', 'depositListUser');
  const [flagSpinner, setFlagSpinner] = useState(false);
  const disableFlag = arrItem.findIndex((item: IPaymentMethod) => item.type === activeItem) !== -1;
  const toggleFlagSpinner = useCallback(
    () => setFlagSpinner((prev) => !prev),
    []
  );
  const {
    flag: flagModalTransfer,
    setModalFlag: setModalModalFlagTransfer,
  } = useModalFlag();

  const cn = cnBind.bind(styles);
  const addItem = () => {
    if (activeItem !== null) { 
      setArrItem([...arrItem, ITEMS_BLOCK_PAY_HERE[activeItem]]);
    }
  };

  const createPaymentMethods = (arr: IPaymentMethod[]) => {
    const payments: TCertificatePayment[] = arr.map((item: IPaymentMethod) => {
      return {
        payment_method: Math.trunc(item.type),
        amount: String(formik.values[item.name as keyof IFormikProps]),
        comment: String(formik.values[item.description_title as keyof IFormikProps]),
      };
    })
    return payments
  };

  const handleClickModal = async (flags: IPrintFlags) => {
    if(priceInfo.set_number_series && (!priceInfo.number_series.number || !priceInfo.number_series.series)) {
      toast.error('Задайте номер и серию сертификата или отключите соответствующий селектор');
      return;
    }

    if (priceInfo.set_number_series && (!validateCertificateNumber(priceInfo.number_series.number) || !validateCertificateNumber(priceInfo.number_series.series))) {
      toast.error('Номер и серия могут содержать только буквы (латиница/кириллица), слеш, тире и нижнее подчеркивание');
      return;
    }

    try {
      const res = await createPaymentCertificate(
        {
          ...flags,
          user: userInfo.id,
          certificate_generator: data.id,
          stock_id: priceInfo ? priceInfo.stock_id : undefined,
          comment: priceInfo.comment !== '' ? priceInfo.comment : undefined,
          certificate_party:
            priceInfo.certificate_party !== ''
              ? priceInfo.certificate_party
              : undefined,
          price:
            currentUser.user_status === TYPE_USER.SUPERUSER
              ? priceInfo.price
              : undefined,
          count: deposit_type !== SIDEBAR_TYPES.MONEY ? count : undefined,
          payments: createPaymentMethods(arrItem),
          set_number_series: priceInfo ? !!priceInfo.set_number_series : false,
          number_series: priceInfo.set_number_series ? [{
            number: priceInfo.number_series?.number as string || '',
            series: priceInfo.number_series?.series as string || '',
          }] : undefined,
        },
        data?.title
      );
      if (flags.print_qr_label || flags.print_pdf) {
        toast(<ToastPrintCertificate data={{ ...res, type: 0 }} />, {
          position: 'top-right',
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          data: { ...res, type: 0 },
        });
      }
      closeModal();
      dispatch('depositListUser/get', { user_id: userInfo.id });
    } catch (e) {
      console.log(e);
    }
  };
  const [stockInfo, setStockInfo] = useContext<any>(ContextDeposit);
  const formik = useFormik<IFormikProps>({
    enableReinitialize: true,
    initialValues: {
      cash: 0,
      transfer: 0,
      deposit: 0,
      card: 0,
      cash_description: '',
      card_description: '',
      transfer_description: '',
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async () => {
      try {
        toggleFlagSpinner();
        if (headerType === TYPES.DEPOSITS) {
          await createPaymentDeposit(
            {
              user_id: userInfo.id,
              stock_id: stockInfo ? stockInfo.id : undefined,
              resource:
                currentUser.user_status === TYPE_USER.SUPERUSER &&
                  deposit_type !== TYPES_DEPOSITS.MONEY 
                  ? priceInfo.resource 
                  : undefined,
              price:
                currentUser.user_status === TYPE_USER.SUPERUSER ||
                  (deposit_type === SIDEBAR_TYPES.MONEY &&
                    Number(data.balance) !== priceInfo.price)
                  ? priceInfo.price
                  : undefined,
              deposit_tariff_rate_id:
                deposit_type !== TYPES_DEPOSITS.MONEY && data.rent_pay_count === undefined ? data?.id : undefined,
              rent_rate_id: data?.rent_pay_count ? data.id : undefined,
              money_deposit_rate_id:
                deposit_type === TYPES_DEPOSITS.MONEY ? data?.id : undefined,
              count: deposit_type !== SIDEBAR_TYPES.MONEY ? count : undefined,
              payments: createPaymentMethods(arrItem),
            },
            deposit_type === TYPES_DEPOSITS.MONEY
              ? data?.name
              : data?.rate_name ?? data?.title
          );
          closeModal();
          dispatch('depositListUser/get', { user_id: userInfo.id });
        } else if (headerType === TYPES.SERVICES) {
          await createPaymentServices(
            {
              user_id: userInfo.id,
              price:
                (Number(data.balance) !== priceInfo.price)
                  ? priceInfo.price
                  : undefined,
              service_id:
                data?.id,
              count,
              payments: createPaymentMethods(arrItem),
            },
            data?.title
          );
          closeModal();
          dispatch('depositListUser/get', { user_id: userInfo.id });
        } else {
          setModalModalFlagTransfer();
        }
        toggleFlagSpinner();
        setStockInfo(null);
      } catch (e) {
        toggleFlagSpinner();
      }
    },
  });
  const deleteItem = (id: number) => {
    const item = arrItem.find((item: IPaymentMethod) => item.type === id);
    if (item) {
      formik.setFieldValue(item.name, 0);
      formik.setFieldValue(item.description_title, '');
      const arr = arrItem.filter((item: Record<string, any>) => item.type !== id);
      setArrItem(arr);
    }
  };

  const countPrice = () => {
    let results = 0;
    arrItem.forEach((item: Record<string, any>) => {
      // @ts-ignore
      results += Number(formik.values[item.name]);
    });
    const price = Number(priceInfo.price_total) - results
    if (activeItem === PAYMENT_TYPE.FROM_DEPOSIT_RUBLES && price > depositListUser.deposit_money) {
      return depositListUser.deposit_money
    }
    return price
  };
  const closeModal = () => {
    onRequestClose();
    setArrItem([]);
    formik.resetForm();
    formik.setValues(formik.initialValues);
  };

  const isDisabledDepositPayment = (id: number) => {
    return id === PAYMENT_TYPE.FROM_DEPOSIT_RUBLES &&
      (depositListUser.deposit_money === 0 || (deposit_type === SIDEBAR_TYPES.MONEY && headerType === TYPES.DEPOSITS))
  }

  useEffect(() => {
    if (data) {
      arrItem.forEach((item: Record<string, any>) => {
        // @ts-ignore
        if (formik.values[item.name] === 0) {
          formik.setFieldValue(item.name, countPrice());
        }
      });
    }
  }, [arrItem]);

  useEffect(() => {
    if (data) {
      arrItem.forEach((item: Record<string, any>, index: number) => {
        if (index === 0) {
          formik.setFieldValue(item.name, data.price);
        } else {
          formik.setFieldValue(item.name, 0);
        }
      });
    }
    
    setActiveItem(null)
  }, [data]);

  const flagDisableBtnPay = checkFlagBtnPay(
    arrItem,
    formik.values,
    priceInfo.price_total
  );

  const headerTitle = () => {
    if (headerType === TYPES.DEPOSITS){
      return deposit_type === SIDEBAR_TYPES.MONEY
      ? data?.name
      : data?.rate_name
    }
    
    return data?.title
  }

  return (
    <ModalLayout flag={flag} size='md' onClose={closeModal}>
      <div className={styles['header']}>
        <div className={styles['header--container']}>
          <h2 className={styles['header--title']}>
            Покупка {headerTypeTitle[headerType]}:{' '}
            {headerTitle()}
          </h2>
        </div>
        <span>
          Кому: {userInfo.first_name} {userInfo.last_name}
        </span>
      </div>
      <GxForm onGx-submit={formik.submitForm}>
        <div className={styles['subheader']}>
          <span className={styles['subheader--subtitle']}>Способ оплаты:</span>
        </div>

        <div className={styles['actions']}>
          {PAYMENT_DEPOSITS_ITEMS.map((item) => (
            <Radio
              key={item.id}
              name='pay'
              disabled={isDisabledDepositPayment(item.id)}
              className={styles['actions--item']}
              checked={activeItem === item.id}
              onClick={() => {
                if (!isDisabledDepositPayment(item.id)) {
                  setActiveItem(item.id);
                }
              }}
            >
              {
                item.id === PAYMENT_TYPE.FROM_DEPOSIT_RUBLES
                  ?
                  `${item.title} (${depositListUser.deposit_money} руб.)`
                  :
                  `${item.title}`
              }
            </Radio>
          ))}
        </div>
        {arrItem.map((item: Record<string, any>) => (
          <div key={item.type} className={styles['wrap-group']}>
            <h2>{item.title}</h2>
            <div className={styles['wrap-group--container']}>
              <div className={styles['group']}>
                <InputNumbers
                  label='Сумма оплаты:'
                  name={item.name}
                  // @ts-ignore
                  value={formik.values[item.name]}
                  onKeyPress={handleOnPressKey}
                  handleInput={(e: Record<string, any>) => {
                    formik.setFieldValue(item.name, e.target.value);
                  }}
                  className={cn({
                    'group--input': true,
                  })}
                  type='number'
                />
                <span className={styles['symbol--price']} />
              </div>
              <div className={styles['group']}>
                <Input
                  label='Примечание:'
                  // @ts-ignore
                  value={formik.values[item.description_title]}
                  name={item.description_title}
                  className={cn(styles['group--input'])}
                  handleChange={(e: Record<string, any>) => {
                    formik.setFieldValue(
                      item.description_title,
                      e.target.value
                    );
                  }}
                />
              </div>
              <GxButton
                className={cn(styles['btn--gray'], styles['btn--gray_delete'])}
                onClick={() => deleteItem(item.type)}
              >
                <GxIcon
                  src={DeleteIcon}
                  className={styles['btn--gray_delete--icon']}
                />
              </GxButton>
            </div>
          </div>
        ))}
        <div className={styles['container']}>
          <GxButton
            className={styles['btn--gray']}
            onClick={addItem}
            disabled={disableFlag || activeItem === null}
          >
            <GxIcon
              src={PlusIcon}
              className={cn(
                styles['container--icon'],
                styles['container--icon_delete']
              )}
            />
            Добавить оплату
          </GxButton>
        </div>
        <div className={styles['footer']}>
          <div className={styles['footer--left-block']}>
            <div className={styles['pay-info']}>
              <div className={styles['pay-info__item']}>
                <p className={styles['pay-info__item_label']}>Сумма заказа:</p>
                <p className={styles['pay-info__item_price']}>
                  {(priceInfo.price * count).toLocaleString()}
                </p>
              </div>
              <div
                className={cn(
                  styles['pay-info__item'],
                  styles['pay-info__item_paid']
                )}
              >
                <p className={styles['pay-info__item_label']}>Cкидка:</p>
                <p className={styles['pay-info__item_price']}>
                  {priceInfo.stock.toLocaleString()}
                </p>
              </div>
              <div className={cn(styles['pay-info__item_container'])}>
                <div
                  className={cn(
                    styles['pay-info__item'],
                    styles['pay-info__item_total']
                  )}
                >
                  <p className={styles['pay-info__item_label']}>
                    К оплате (руб):
                  </p>
                  <p className={styles['pay-info__item_total']}>
                    <span className={styles['pay-info__item_price']}>
                      {priceInfo.price_total.toLocaleString()}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['footer--right-block']}>
            <GxButton className={styles['btn--gray']} onClick={closeModal}>
              Отмена
            </GxButton>

            {flagSpinner ? (
              <GxSpinner style={{ fontSize: '2rem' }} />
            ) : (
              <GxButton
                className={styles['btn--default']}
                type='submit'
                disabled={!flagDisableBtnPay}
              >
                Оплатить
              </GxButton>
            )}
          </div>
        </div>
      </GxForm>
      <ModalTransferCertificate
        flag={flagModalTransfer}
        onRequestClose={setModalModalFlagTransfer}
        user={userInfo}
        onSave={handleClickModal}
        type='sale'
      />
    </ModalLayout>
  );
};
export default ModalPayHere;
